
export async function decodeBase64(base64: string): Promise<Uint8Array> {
  const dataUrl = 'data:application/octet-binary;base64,' + base64;
  const fetched = await fetch(dataUrl);
  const decoded = await fetched.arrayBuffer();
  return new Uint8Array(decoded);
}

export function decodeBase64Sync(base64: string): Uint8Array {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}